/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-return': {
    width: 19,
    height: 15,
    viewBox: '0 0 19 15',
    data: '<path pid="0" d="M17.395 8.895l.028-.006H5.518l3.743 3.75a.974.974 0 01.284.692c0 .26-.1.507-.284.69l-.582.583a.966.966 0 01-.688.285c-.26 0-.504-.101-.687-.284L.888 8.19a.964.964 0 01-.283-.689c-.001-.262.1-.507.283-.69L7.304.394A.966.966 0 017.99.112c.26 0 .504.1.688.283l.582.583a.964.964 0 01.284.687c0 .26-.1.492-.284.675L5.476 6.11H17.41c.536 0 .986.462.986.998v.824c0 .536-.463.962-1 .962z" _fill="#fff"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/arrow-return.js